import { render, staticRenderFns } from "./funding-tab.vue?vue&type=template&id=12960086"
import script from "./funding-tab.vue?vue&type=script&lang=js"
export * from "./funding-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports